(function () {
  'use strict';

  angular.module('app').component('tourContentsPage', TourContentsPageComponent());

  function TourContentsPageComponent() {
    return {
      bindings: {},
      controller: TourContentListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tour-contents/tour-contents-page.component.html',
    };
  }

  TourContentListCtrl.$inject = [
    '$location',
    'UtilService',
    'AbilityService',
    'SessionService',
    '$routeParams',
    'TourService',
    'TourContentService',
    'LanguageService',

    // Angular downgraded service
    'ng2Router',
  ];

  function TourContentListCtrl(
    $location,
    UtilService,
    AbilityService,
    SessionService,
    $routeParams,
    TourService,
    TourContentService,
    LanguageService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var companyWebsites = SessionService.getSelectedAccountCompany().websites;

    if (companyWebsites.length === 0) {
      vm.errorWebsites = true;
    }

    vm.permissions = {
      canCreate: AbilityService.can('create_tour_accountadmin'),
    };

    vm.websiteId = $routeParams.WSID;
    vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
    vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

    // Methods
    vm.addTourContent = addTourContent;
    vm.onTourContentShowed = onTourContentShowed;

    vm.openTourListModal = openTourListModal;

    // Initializers
    getDefaultLanguage();
    // getToursContents();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getToursContents();
      });
    }

    function getToursContents() {
      vm.filterCriteria = TourContentService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      TourContentService.getToursContents(vm.websiteId, vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function addTourContent() {
      $location.path(`/tour_contents/new`).search({ WSID: vm.websiteId });
    }

    function onTourContentShowed(item, mode) {
      $location.path(`/tour_contents/${item.id}`).search({ WSID: vm.websiteId, mode: mode });
    }

    function openTourListModal() {
      //   var tourIds = [];

      //   vm.items.forEach(function (content) {
      //     tourIds.push(content.tour_id);
      //   });

      TourService.openTourListModal(vm.websiteId); // tourIds,
    }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };

    vm.goToWebsiteNew = () => {
      ng2Router.navigate(['/ng/websites/new']);
    };
  }
})();
